/* eslint-disable no-mixed-operators */
import React, {Component, Fragment} from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'underscore';
import download from 'downloadjs';
import classnames from 'classnames';
import prettyMs from 'pretty-ms';
import merge from 'lodash.merge';
import { scroller } from 'react-scroll'
import SparkMD5 from 'spark-md5';
import base64 from 'base-64';

import { Modal, ModalHeader, ModalBody, ModalFooter, Button,
    Table, TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';

import ActivityBadge from '../../../../../components/ActivityBadge';
import { processActivityToTag, NoStringsExtracted } from '../../../../../constants/sandbox';
import TitleBanner from '../../../../../components/TitleBanner';
import TCPConnectionRows from '../../../../../components/TCPConnectionRows';

import { fetchStrings, fetchDataConnection } from '../../../../../services/sandbox';
import { fetchDroppedFile } from '../../../../../services/download';
import { setInjectedProcess } from '../../../../../actions/sandbox';

import { faStopCircle, faStickyNote } from '@fortawesome/free-regular-svg-icons';
import { faPowerOff,
  faAlignJustify,
  faPlusSquare,
  faMinusSquare,
  faNetworkWired,
  faSyringe,
  faIndent,
  faSpinner,
  faFileDownload
 } from '@fortawesome/free-solid-svg-icons';

import style from '../../style.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { statusSuccess } from '../../../../../constants/api';
import { handleError } from '../../../../../services/errorHandler';
import StringBadge from '../../../../../components/StringBadge';
import { setTimeout } from 'timers';

class DynamicProcess extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: SparkMD5.hash(this.props.path + this.props.pid),
      enlighted: false,
      hidden: true,
      activeTab: 0,
      activeTabInjected: 0,
      connectionDataModal: false,
      stringsDataModal: false,
      parsedStringDataModal: false,
      connectionData: '',
      stringsData: '',
      parsedStringData: {},
      injected_threads_activities: {},
      isDownloading: false
    }
  }

  downloadSample = dropped => {
    const { mainHash, platform } = this.props;

    this.setState({
      isDownloading: true
    }, () => {
      fetchDroppedFile(mainHash, platform, dropped).then(response => {
        return response.blob();
      }).then(myBlob => download(myBlob, `${mainHash}.deepviz`, 'application/octet-stream')).finally(() => {
        this.setState({
          isDownloading: false
        })
      })
    })
  }

  componentDidMount() {
    const { injected_threads_activities } = this.props;
    
    if(injected_threads_activities.length > 0) {
      this.setState({
        injected_threads_activities: merge(...injected_threads_activities)
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { name } = this.state;
    const { currentInjectedProcess } = this.props;
    const { currentInjectedProcess: prevInjectedProcess } = prevProps;

    if(currentInjectedProcess && prevInjectedProcess !== currentInjectedProcess && currentInjectedProcess === name) {
      this.setState({
        enlighted: true,
        hidden: false
      }, () => {
        setTimeout(() => {
          this.props.setInjectedProcess(null);
          this.setState({
            enlighted: false
          })
        }, 2000);
      })
    }
  }

  toggleConnectionDataModal = () => {
    this.setState(prevState => ({
      connectionDataModal: !prevState.connectionDataModal
    }));
  }

  toggleStringsModal = () => {
    this.setState(prevState => ({
      stringsDataModal: !prevState.stringsDataModal
    }));
  }

  toggleParsedStringModal = () => {
    this.setState(prevState => ({
      parsedStringDataModal: !prevState.parsedStringDataModal
    }));
  }

  renderConnectionDataModal = () => {
    const {connectionDataModal, connectionData} = this.state;

    return <Modal isOpen={connectionDataModal} toggle={this.toggleConnectionDataModal} size='lg'>
      <ModalHeader toggle={this.toggleConnectionDataModal}>Data Connection</ModalHeader>
      <ModalBody>
        <textarea readOnly className={style.stringsContainer} defaultValue={base64.decode(connectionData).replace(/\\n/g, '<br />')}></textarea>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={this.toggleConnectionDataModal}>Close</Button>
      </ModalFooter>
    </Modal>
  }

  renderStringsDataModal = () => {
    const {stringsDataModal, stringsData} = this.state;

    return <Modal isOpen={stringsDataModal} toggle={this.toggleStringsModal} size='xl'>
      <ModalHeader toggle={this.toggleStringsModal}>Strings</ModalHeader>
      <ModalBody>
        <textarea readOnly className={style.stringsContainer} defaultValue={base64.decode(stringsData).replace(/\\n/g, '<br />')}></textarea>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={this.toggleStringsModal}>Close</Button>
      </ModalFooter>
    </Modal>
  }

  renderParsedStringsDataModal = () => {
    const {parsedStringDataModal, parsedStringData} = this.state;

    return <Modal isOpen={parsedStringDataModal} toggle={this.toggleParsedStringModal} size='xl'>
      <ModalHeader toggle={this.toggleParsedStringModal}>Extracted strings</ModalHeader>
      <ModalBody className={style.parsedStringContainer}>
      {typeof parsedStringData === 'string'? <p className={style.extractedStringElement}>{parsedStringData}</p> :
        Object.entries(parsedStringData).map((strings, idx) => {
          return _.isEmpty(strings[1]) ? null :
          <div key={idx} className="mb-3">
            <p className={style.extractedStringTitle}>{strings[0]}</p>
            {strings[1].map((s, idx) => <p className={style.extractedStringElement} key={idx}>{s}</p>)}
          </div>
        })
      }
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={this.toggleParsedStringModal}>Close</Button>
      </ModalFooter>
    </Modal>
  }

  toggleTab = tab => {
    if (this.state.activeTab !== tab) {
      this.setState({
         activeTab: tab
      });
    }
  }

  toggleTabInjected = tab => {
    if (this.state.activeTabInjected !== tab) {
      this.setState({
        activeTabInjected: tab
      })
    }
  }

  toggleVisibility = () => {
    this.setState(prevState => ({
      hidden: !prevState.hidden
    }));
  }

  renderHashes = hash => <Table size="sm" responsive bordered striped>
    <tbody>
    {Object.entries(hash).map((h, idx) => <tr key={idx}>
      <td className={style.title}>{h[0]}</td>
      <td>{h[1]}</td>
    </tr>)}
    </tbody>
  </Table>

  renderProcessActivities = (activities, process_information = {}, isInjected = null) => {
    const activeTab = isInjected ? this.state.activeTabInjected : this.state.activeTab;
    const toggleTab = isInjected ? this.toggleTabInjected : this.toggleTab;
    const activitiesLength = activities ? Object.entries(activities).length : 0;
  
    return <div className={isInjected ? style.injectedThreadActivities : null}>
      {isInjected && <TitleBanner level='danger' icon={faSyringe} marginBottom={true}>Injected Thread activities</TitleBanner>}
      <Nav tabs className={isInjected ? style.injectedThreadActivitiesNavTabs : null}>
        {Object.entries(activities).map((activity, inner_idx) => {
          return <NavItem key={inner_idx}>
            <NavLink
              className={classnames(
                style.dynamicTabs,
                { 'font-weight-bold': activeTab === inner_idx, active: activeTab === inner_idx },
                isInjected && activeTab === inner_idx ? style.injectedThreadActivitiesNav : null
                )}
              onClick={() => { toggleTab(inner_idx); }}
            >
              {activity[0].replace(/_/g, " ")}
            </NavLink>
          </NavItem>
        })}
        {Object.entries(process_information).map((information, inner_idx) => {
          //We have to shift this tabs after the activities' ones
          inner_idx = inner_idx + activitiesLength;
          
          return <NavItem key={inner_idx + activitiesLength}>
            <NavLink
              className={classnames(
                style.dynamicTabs,
                { 'font-weight-bold': activeTab === inner_idx, active: activeTab === inner_idx },
                style.infoTabs
              )}
              onClick={() => { toggleTab(inner_idx); }}
            >
              {information[0].replace(/_/g, " ")}
            </NavLink>
          </NavItem>
        })}
      </Nav>
      <TabContent activeTab={activeTab} >
        {Object.entries(activities).map((activity, inner_idx) =>
          <TabPane tabId={inner_idx} key={inner_idx} className={classnames(style.dynamicTabsContainer, isInjected ? style.injectedThreadActivitiesContent : null)}>
            <Row>
              <Col sm="12">
                {this.renderProcessAcitivtyContent(activity)}
              </Col>
            </Row>
          </TabPane>
        )}
        {Object.entries(process_information).map((information, inner_idx) =>
          <TabPane tabId={inner_idx + activitiesLength} key={inner_idx + activitiesLength} className={style.dynamicTabsContainer}>
            <Row>
              <Col sm="12">
                {this.renderProcessAcitivtyContent(information)}
              </Col>
            </Row>
          </TabPane>
        )}
      </TabContent>
    </div>
  }
  

  renderProcessAcitivtyContent = activity => {
    switch(activity[0]) {
      case 'network':
        return this.renderNetwork(activity[1]);
      case 'code_injection':
        return this.renderCodeInjection(activity[1]);
      case 'dynamic_imported_function':
        return this.renderDynamicImportedFunction(activity[1]);
      case 'registry':
        return this.renderRegistry(activity[1]);
      case 'mutex':
        return this.renderMutex(activity[1]);
      case 'hook':
        return this.renderHook(activity[1]);
      case 'process':
        return this.renderProcess(activity[1]);
      case 'file_system':
        return this.renderFileSystem(activity[1]);
      case 'load_image':
        return this.renderLoadImage(activity[1]);
      case 'shutdown':
        return this.renderShutdown(activity[1]);
      case 'sleep':
        return this.renderSleep(activity[1]);
      case 'raw_disk_access':
        return this.renderRawDiskAccess(activity[1]);
      case 'injected_code':
        return this.renderInjectedCode(activity[1]);
      default:
        return null;
    }
  }

  renderInjectedCode = injectedCode => <Table size="sm" responsive bordered striped>
    <thead>
      <tr>
        <td className={style.title} style={{ width: '50px'}}>Strings</td>
        <td className={style.title}>Virtual Address</td>
        <td className={style.title}>Code Size</td>
      </tr>
    </thead>
    <tbody>
      {injectedCode.map((inj, idx) => <tr key={idx}>
        <td className="centeredCell">
          <FontAwesomeIcon
            title={inj.md5_strings ? 'Click to view strings' : 'No strings available'}
            className={inj.md5_strings ? 'cursorPointer' : 'cursorNotAllowed'}
            icon={faAlignJustify}
            onClick={inj.md5_strings ? () => { this.loadStrings(inj.md5_strings) } : () => {}}
          />
          {!!inj.md5_strings && !!this.props.strings[inj.md5_strings] && <FontAwesomeIcon
            title={'Click to view extracted strings'}
            className={style.extractedString}
            icon={faIndent}
            onClick={() => {this.unwrapExtractedString(this.props.strings[inj.md5_strings].extracted_strings)}}
          />}
        </td>
        <td>{inj.virtual_address}</td>
        <td>{inj.code_size}</td>
      </tr>)}
    </tbody>
  </Table>

  renderNetwork = networks => {
    const { connections, local_services } = networks;
    return <>
      {!!connections && this.renderNetworkConnections(connections)}
      {!!local_services && this.renderNetworkLocalServices(local_services)}
    </>
  }

  renderNetworkLocalServices = local_services => {
    const { udp, tcp } = local_services;
    return <>
      <TitleBanner icon={faNetworkWired}>Local Services</TitleBanner>
      <Table size="sm" responsive bordered striped>
        <thead>
          <tr>
            <td className={style.title}>Type</td>
            <td className={style.title}>Local address</td>
            <td className={style.title}>Remote address</td>
            <td className={style.title}>State</td>
          </tr>
        </thead>
        <tbody>
          {!!tcp && tcp.map((t, idx) => <tr key={idx}>
            <td>TCP</td>
            <td>{t.local_address} : {t.local_port}</td>
            <td>{t.remote_address} : {t.remote_port}</td>
            <td>{t.state}</td>
          </tr>)}
          {!!udp && udp.map((t, idx) => <tr key={idx}>
            <td>UDP</td>
            <td>{t.local_address} : {t.local_port}</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>)}
        </tbody>
      </Table>
    </>
  }

  renderNetworkConnections = connections => {
    const { tcp, udp, icmp } = connections;
    return <>
      {!!tcp && this.renderNetworkTcp(tcp)}
      {!!udp && this.renderNetworkUdp(udp)}
      {!!icmp && this.renderNetworkIcmp(icmp)}
    </>
  }

  loadDataConnection = (protocol, conn_id, event_type, event_id = null) => {
    const { mainHash, platform } = this.props;
    fetchDataConnection(mainHash, platform, protocol, conn_id, event_type, event_id).then(res => {
      if(res.status === statusSuccess) {
        if(_.isEmpty(res.data)) {
          handleError('Info', 'Connection data is empty', 'info');
        } else {
          this.setState({
            connectionDataModal: true,
            connectionData: res.data
          });
        }
      } else {
        handleError('Error', 'Error downloading connection data');
      }
    })
  }

  loadStrings = block => {
    const { mainHash, platform } = this.props;
     fetchStrings(mainHash, platform, block).then(res => {
      if(res.status === statusSuccess) {

        if(res.data === "") {
          res.data = base64.encode(NoStringsExtracted)
        }

        this.setState({
          stringsDataModal: true,
          stringsData: res.data
        });
      } else {
        handleError('Error', 'Error downloading strings data');
      }
    });
  }

  renderNetworkIcmp = icmp => <>
    <TitleBanner icon={faNetworkWired}>ICMP</TitleBanner>
    <Table size="sm" responsive bordered striped>
      <thead>
        <tr>
          <td className={style.title}>IP Address</td>
          <td className={style.title}>Send Size</td>
          <td className={style.title}>Send Type</td>
          <td className={style.title}>Send Code</td>
          <td className={style.title}>Send Data</td>
          <td className={style.title}>Receive Size</td>
          <td className={style.title}>Receive Type</td>
          <td className={style.title}>Receive Code</td>
          <td className={style.title}>Receive Data</td>
        </tr>
      </thead>
      <tbody>
        {icmp.map((conn, idx) => {
          const { ip, connection_id, send, receive } = conn;
          return <tr key={idx}>
          <td>{ip}</td>
          <td>{!!send && send.data_size}</td>
          <td>{!!send && send.type}</td>
          <td>{!!send && send.code}</td>
          <td className='centeredCell'>
            {!!send && <FontAwesomeIcon icon={faAlignJustify} className='cursorPointer' onClick={() => this.loadDataConnection('icmp', connection_id, 'send')}/>}
          </td>
          <td>{!!receive && receive.data_size}</td>
          <td>{!!receive && receive.type}</td>
          <td>{!!receive && receive.code}</td>
          <td>{!!receive && <FontAwesomeIcon icon={faAlignJustify} className='cursorPointer' onClick={() => this.loadDataConnection('icmp', connection_id, 'recv')}/>}</td>
        </tr>})}
      </tbody>
    </Table>
  </>

  renderNetworkUdp = udp => <>
    <TitleBanner icon={faNetworkWired}>UDP Connections</TitleBanner>
    <Table size="sm" responsive bordered striped>
      <thead>
        <tr>
          <td className={style.title} style={{width: '1%'}}>Data</td>
          <td className={style.title}>Address</td>
          <td className={style.title}>Data Size</td>
        </tr>
      </thead>
      <tbody>
          {udp.map((conn, idx) => <tr key={idx}>
            <td className='centeredCell'><FontAwesomeIcon icon={faAlignJustify} className='cursorPointer' onClick={() => { this.loadDataConnection('udp', conn.connection_id, 'send'); }} /></td>
            <td>{conn.ip}:{conn.port}</td>
            <td>{!!conn.send && conn.send.data_size}</td>
          </tr>)}
      </tbody>
    </Table>
  </>

  renderNetworkTcp = tcp => <>
    <TitleBanner icon={faNetworkWired}>TCP Connections</TitleBanner>
    <Table size="sm" responsive bordered striped>
      <thead>
        <tr>
          <td className={style.title} style={{width: '1%'}}>Data</td>
          <td className={style.title}>Type</td>
          <td className={style.title}>Address</td>
          <td className={style.title}>URL / Host</td>
          <td className={style.title}>Referer</td>
          <td className={style.title}>User agent</td>
          <td className={style.title}>Data Size</td>
        </tr>
      </thead>
      <tbody>
          {tcp.map((t, idx) => <TCPConnectionRows key={idx} connection={t} loadDataConnection={this.loadDataConnection}/>)}
      </tbody>
    </Table>
  </>

  renderCodeInjection = codeInjections => <Table size="sm" responsive bordered striped>
    <thead>
      <tr>
        <td className={style.title} style={{width: '50px'}}>Strings</td>
        <td className={style.title}>Target</td>
        <td className={style.title}>Virtual address</td>
        <td className={style.title}>Code size</td>
      </tr>
    </thead>
    <tbody>
    {codeInjections.map((cj, idx) => {
      const hashInjectedProcess = SparkMD5.hash(cj.target_process_path + cj.target_pid);

      const targetAttributes = [];

      if(cj.hasOwnProperty('target_process_version') && cj.target_process_version !== "")
        targetAttributes.push(`v. ${cj.target_process_version}`);

        if(cj.hasOwnProperty('target_pid') && cj.target_pid !== "")
        targetAttributes.push(`PID: ${cj.target_pid}`);

      if(cj.hasOwnProperty('target_tid') && cj.target_tid !== "")
        targetAttributes.push(`TID: ${cj.target_tid}`);

      return <tr key={idx}>
        <td className='centeredCell'>
          <FontAwesomeIcon
            title={cj.md5_strings ? 'Click to view strings' : 'No strings available'}
            className={cj.md5_strings ? 'cursorPointer' : 'cursorNotAllowed'}
            icon={faAlignJustify}
            onClick={cj.md5_strings ? () => { this.loadStrings(cj.md5_strings) } : () => {}}
          />
          {!!cj.md5_strings && !!this.props.strings[cj.md5_strings] && <FontAwesomeIcon
            title={'Click to view extracted strings'}
            className={style.extractedString}
            icon={faIndent}
            onClick={() => {this.unwrapExtractedString(this.props.strings[cj.md5_strings].extracted_strings)}}
          />}
        </td>
        <td>
          <Button
            className="fakeLink"
            color="link"
            size="sm"
            onClick={() => {
              this.props.setInjectedProcess(hashInjectedProcess);
              scroller.scrollTo(hashInjectedProcess, { offset: -50, smooth: true });
            }}
          >
            {cj.target_process_path}
            {!!targetAttributes.length && ` (${targetAttributes.join(' | ')})`}
          </Button>
        </td>
        <td>{cj.virtual_address}</td>
        <td>{cj.code_size}</td>
      </tr>})}
    </tbody>
  </Table>

  renderDynamicImportedFunction = functions => functions.map((func, idx) => <Table size="sm" responsive bordered striped key={idx}>
    <thead>
      <tr>
        <td className={style.title} style={{width: '250px'}}>Module</td>
        <td className={style.title}style={{width: 'auto', 'maxWidth': 'auto'}}>Api</td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>{func.module}</td>
        <td>{func.functions.map((f, idx) => <p className='mb-0' key={idx}>
          {f.name ? `Name: ${f.name}` : `Ordinal: ${f.ordinal}`}  
        </p>)}
        </td>
      </tr>
    </tbody>
  </Table>);

  renderRegistry = registries => {
    return Object.entries(registries).map((registry, idx) => <Fragment key={idx}>
      <TitleBanner icon={faStickyNote}>{registry[0].replace(/_/g, ' ')} [{registry[1].length}]</TitleBanner>
      {registry[0] === 'open_key' || registry[0] === 'create_key' ?
        this.renderRegistryKeyTable(registry[1]) : 
        registry[1].map((reg, idx) => this.renderRegistryTable(reg, idx))}
    </Fragment>);
  }

  renderMutex = mutexes => !!mutexes && <Table size="sm" responsive bordered striped>
    <tbody>
      {mutexes.map((mutex, idx) => <tr key={idx}>
        <td>{mutex.name}</td>
      </tr>)}
    </tbody>
  </Table>

  renderHook = hooks => !!hooks && <Table size="sm" responsive bordered striped>
    <thead>
      <tr>
        <td className={style.title}>Module</td>
        <td className={style.title}>Hooks</td>
      </tr>
    </thead>
    <tbody>
      {!!hooks.user && hooks.user.map((hook, idx) => <tr key={idx}>
        <td>{hook.module}</td>
        <td>
          {!!hook.api_list && <Table size="sm" responsive bordered>
            <thead>
              <tr>
                <td>API</td>
                <td>Destination module</td>
                <td>Type</td>
                <td>Address</td>
              </tr>
            </thead>
            <tbody>
              {hook.api_list.map((api, idx) => <tr key={idx}>
                <td>{api.name}</td>
                <td>{api.destination_module}</td>
                <td>{api.hook_type}</td>
                <td>{api.virtual_address}</td>
              </tr>)}
            </tbody>
          </Table>}
        </td>
      </tr>)}
    </tbody>
  </Table>

  renderProcess = processes => {
    const { terminate, create } = processes;
    return <>
      {!!create && <>
        <TitleBanner>Process creation</TitleBanner>
        <Table size="sm" responsive bordered striped>
          <thead>
            <tr>
              <td className={style.title}>Path</td>
              <td className={style.title}>Command line</td>
              <td className={style.title}>MD5</td>
            </tr>
          </thead>
          <tbody>
            {create.map((cr, idx) => <tr key={idx}>
              <td>{cr.path} {cr.version && `[v. ${cr.version}]`} {cr.pid && `(PID: ${cr.pid})`}</td>
              <td>{cr.command_line}</td>
              <td>{!!cr.hash && <Link to={`/sandbox/report/${cr.hash.sha512}/`}>{cr.hash.md5}</Link>}</td>
            </tr>)}
          </tbody>
        </Table>
      </>}
      {!!terminate && !!terminate.length &&
        <TitleBanner icon={faStopCircle} level='danger' marginBottom={true}>This process has terminated</TitleBanner>
      }
    </>
  }

  renderFileSystem = file_system => {
    const { create, write, read, delete: del, rename, hide } = file_system;

    return !!file_system && <Table size="sm" responsive bordered striped>
      <thead>
        <tr>
          <td className={style.title}>Type</td>
          <td className={style.title}>File type</td>
          <td className={style.title}>File path</td>
          <td className={style.title}>Hash</td>
          <td className={style.title} style={{width: '1%'}}>Download</td>
        </tr>
      </thead>
      <tbody>
        {!!create && create.map((fs, idx) => this.renderActivityRow(fs, 'CREATE', idx))}
        {!!write && write.map((fs, idx) => this.renderActivityRow(fs, 'WRITE', idx))}
        {!!read && read.map((fs, idx) => this.renderActivityRow(fs, 'READ', idx))}
        {!!del && del.map((fs, idx) => this.renderActivityRow(fs, 'DELETE', idx))}
        {!!rename && rename.map((fs, idx) => {          
          fs = {
            ...fs,
            file_path: <>
              <p className="mb-0"><strong>Old</strong>: {fs.file_path}</p>
              <p className="mb-0"><strong>New</strong>: {fs.new_file_path}</p>
            </>
          };
          return this.renderActivityRow(fs, 'RENAME', idx);
        })}
        {!!hide && hide.map((fs, idx) => this.renderActivityRow(fs, 'HIDE', idx))}
      </tbody>
    </Table>
  }

  renderLoadImage = loadImages => !!loadImages && <Table size="sm" responsive bordered striped>
    <thead>
      <tr>
        <td className={style.title} style={{ width: '50px' }}>Data</td>
        <td className={style.title}>Type</td>
        <td className={style.title}>File type</td>
        <td className={style.title}>File path</td>
        <td className={style.title}>Hash</td>
        <td className={style.title} style={{width: '1%'}}>Download</td>
      </tr>
    </thead>
    <tbody>
    {!!loadImages.kernel && loadImages.kernel.map((li, idx) => this.renderActivityRow(li, 'KERNEL', idx, true))}
    {!!loadImages.user && loadImages.user.map((li, idx) => this.renderActivityRow(li, 'USER', idx, true))}
    </tbody>
  </Table>

  renderSleep = sleeps => !!sleeps && <Table size="sm" responsive bordered striped>
    <thead>
      <tr>
        <td className={style.title}>Value</td>
      </tr>
    </thead>
    <tbody>
    {sleeps.map((sleep, idx) => 
      <tr key={idx}>
        <td>{prettyMs(sleep.value)}</td>
      </tr>
    )}
    </tbody>
  </Table>

  renderShutdown = shutdowns => !!shutdowns && <TitleBanner icon={faPowerOff} level='danger'>
    The process did {shutdowns.length} shutdown attempt{shutdowns.length > 1 ? 's' : ''}
  </TitleBanner>

  renderRawDiskAccess = accesses => <Table size="sm" responsive bordered striped>
    <thead>
      <tr>
        <td className={style.title}>Type</td>
        <td className={style.title}>Data</td>
        <td className={classnames(style.title, "hasToBeSingleLine")}>Data size</td>
      </tr>
    </thead>
    <tbody>
    {!!accesses.mbr && accesses.mbr.map((access, idx) => 
      <tr key={idx}>
        <td><strong>MBR</strong></td>
        <td className="containsLongWords">{access.data}</td>
        <td className="hasToBeSingleLine">{access.data_size}</td>
      </tr>
    )}
    {!!accesses.vbr && accesses.vbr.map((access, idx) => 
      <tr key={idx}>
        <td><strong>VBR</strong></td>
        <td className="containsLongWords">{access.data}</td>
        <td className="hasToBeSingleLine">{access.data_size}</td>
      </tr>
    )}
    {!!accesses.generic_info && accesses.generic_info.map((access, idx) => 
      <tr key={idx}>
        <td><strong>GENERIC</strong></td>
        <td className="containsLongWords">{access.data}</td>
        <td className="hasToBeSingleLine">{access.data_size}</td>
      </tr>
    )}
    {!!accesses.disk_info && accesses.disk_info.map((access, idx) => 
      <tr key={idx}>
        <td><strong>Access to hard disk name</strong></td>
        <td className="containsLongWords">&nbsp;</td>
        <td className="hasToBeSingleLine">&nbsp;</td>
      </tr>
    )}
    </tbody>
  </Table>;

  renderActivityRow = (activity, type, idx, isloadImage = false) => {
    const isDropped = activity.hash && activity.hash.sha512 && _.findWhere(this.props.dropped, {sha512: activity.hash.sha512});
    const { isDownloading } = this.state;

    return <tr key={idx}>
      {isloadImage && <td className='centeredCell'>
        <FontAwesomeIcon
          title={activity.md5_strings ? 'Click to view strings' : 'No strings available'}
          className={activity.md5_strings ? 'cursorPointer' : 'cursorNotAllowed'}
          icon={faAlignJustify}
          onClick={activity.md5_strings ? () => { this.loadStrings(activity.md5_strings) } : () => {}}
        />
        {!!activity.md5_strings && !!this.props.strings[activity.md5_strings] && <FontAwesomeIcon
          title={'Click to view extracted strings'}
          className={style.extractedString}
          icon={faIndent}
          onClick={() => {this.unwrapExtractedString(this.props.strings[activity.md5_strings].extracted_strings)}}
        />}
      </td>}
      <td>{type}</td>
      <td>{activity.file_type}</td>
      <td>{activity.file_path}</td>
      <td>{activity.hash && activity.hash.md5}</td>
      <td className='text-center'>{isDropped ?
        isDownloading ? <FontAwesomeIcon icon={faSpinner} spin /> :
        <FontAwesomeIcon className='cursorPointer' icon={faFileDownload} onClick={() => { this.downloadSample(activity.hash.sha512) }}/> : null
      }</td>
    </tr>
  }

  renderRegistryKeyTable = registry => <Table size="sm" responsive bordered striped>
    <tbody>
      {registry.map((reg, idx) => <tr key={idx}>
        <td className={style.title}>Key</td>
        <td>{reg.key}</td>
      </tr>)}
    </tbody>
  </Table>

  renderRegistryTable = (activity, idx) => {
    const { key, value_name, value_type, value_data, value_data_size } = activity;

    return <Table size="sm" responsive bordered striped key={idx}>
      <tbody>
        <tr>
          <td className={style.title}>Key</td>
          <td className="containsLongWords">{key}</td>
        </tr>
        {!!value_name && <tr>
          <td className={style.title}>Name</td>
          <td className="containsLongWords">{value_name}</td>
        </tr>}
        {!!value_type && <tr>
          <td className={style.title}>Type</td>
          <td className="containsLongWords">{value_type}</td>
        </tr>}
        {!!value_data && <tr>
          <td className={style.title}>Data</td>
          <td className="containsLongWords">{value_data}</td>
        </tr>}
        {!!value_data_size && <tr>
          <td className={style.title}>Data size</td>
          <td className="containsLongWords">{value_data_size}</td>
        </tr>}
      </tbody>
    </Table>
  }

  renderActivityBadge = () => {
    const activitiesKeys = _.union(Object.keys(this.props.process_activities), Object.keys(this.state.injected_threads_activities));

    return <div className="float-right">
      {activitiesKeys.map((activity, idx) => <ActivityBadge value='unknown' label={processActivityToTag[activity]} key={idx} />)}
      {Object.entries(this.props.process_information).map((information, idx) => <ActivityBadge info={true} value='unknown' label={processActivityToTag[information[0]]} key={idx} />)}
    </div>
  }

  renderStringsBadge = (md5_strings, extracted_strings, emptyProcess) => <div className="float-right">
    <StringBadge onClick={() => this.loadStrings(md5_strings)} />
    { _.filter(extracted_strings, s => _.isArray(s) && !_.isEmpty(s)).length > 0 &&
      <StringBadge extracted={true} onClick={() => { this.unwrapExtractedString(extracted_strings) }} />}
    {!emptyProcess && <span className={style.badgeSeparator}></span>}
  </div>

  unwrapExtractedString = parsedStringData => {
    let emptyArray = true;

    Object.entries(parsedStringData).map((strings) => {
      if(strings[1].length > 0) {
        emptyArray = false;
      }
      return null;
    })

    if(emptyArray) parsedStringData = NoStringsExtracted;

    this.setState({
      parsedStringData,
      parsedStringDataModal: true
    })
  }

  render() {
    const { path, version, pid, hash, process_information, process_activities, md5_strings, strings } = this.props;
    const { hidden, injected_threads_activities, name, enlighted } = this.state;

    const emptyProcess = _.isEmpty(injected_threads_activities) && _.isEmpty(process_activities) && _.isEmpty(process_information);

    return <>
      <TitleBanner
        size='big'
        icon={hidden ? faPlusSquare : faMinusSquare}
        onClick={this.toggleVisibility}
        name={name}
        enlighted={enlighted}
      >
        <strong className="cursorPointer" onClick={this.toggleVisibility}>{path}</strong> <span style={{ zoom: '90%'}}>{version && `[v. ${version}]`} {pid && `(PID: ${pid})`}</span>
        {(!_.isEmpty(process_activities) || !_.isEmpty(process_information) || !_.isEmpty(injected_threads_activities)) && this.renderActivityBadge()}
        {!!md5_strings && this.renderStringsBadge(md5_strings, !!strings[md5_strings] && strings[md5_strings].extracted_strings, emptyProcess)}
      </TitleBanner>
      <div className={classnames({ 'd-none': hidden})}>
        {hash && this.renderHashes(hash)}
        {(!_.isEmpty(process_activities) || !_.isEmpty(process_information)) &&
            this.renderProcessActivities(process_activities, process_information, false)}
        {!_.isEmpty(injected_threads_activities) &&
            this.renderProcessActivities(injected_threads_activities, {}, true)}
        { emptyProcess && <TitleBanner level='danger' marginBottom={true}>The process did not take any action</TitleBanner> }
      </div>
      <hr style={{ margin: '2em 0'}} />
      {this.renderConnectionDataModal()}
      {this.renderStringsDataModal()}
      {this.renderParsedStringsDataModal()}
    </>
  }
}

export default connect(
  state => ({
    currentInjectedProcess: state.sandbox.injectedProcess
  }),
  dispatch => ({
    setInjectedProcess: data => dispatch(setInjectedProcess(data))
  })
)(DynamicProcess);
